module.exports = __webpack_public_path__ + "images/application/i-add-fill-grey-32d59323.svg";